import Decimal from 'decimal.js';

export class BookingPreconfirmationTotals {

    constructor(
        public label: string,
        public valueInBase: Decimal,
        public valueInSecond: Decimal
    ){}
}
